import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.34 15.851q-1.033-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75q1.057 0 2.09-.09m0 9.18q.381 1.445.985 2.784c.247.55.06 1.21-.463 1.511l-.657.379c-.551.318-1.26.117-1.527-.46a21 21 0 0 1-1.44-4.283m3.102.07a18 18 0 0 1-.59-4.59c0-1.587.205-3.125.59-4.59m0 9.18a23.9 23.9 0 0 1 8.835 2.535M10.34 6.672a23.9 23.9 0 0 0 8.835-2.535m0 0q-.177-.57-.38-1.125m.38 1.125a24 24 0 0 1 1.014 5.395m-1.014 8.855q-.177.569-.38 1.125m.38-1.125a24 24 0 0 0 1.014-5.395m0-3.46a2.25 2.25 0 0 1 0 3.46m0-3.46a24 24 0 0 1 0 3.46"
    }, null, -1)
  ])))
}
export default { render: render }